<template>
  <div
    class="button-container"
    :style="status !== 'done' && { backgroundColor: 'rgba(0, 0, 0, 0.5)' }"
  >
    <div class="section">
      <div>HOW ARE YOU DOING TODAY ?</div>
    </div>
    <div class="section">
      <transition name="fade">
        <div v-if="status !== 'done'">{{ status }}</div>
      </transition>
    </div>
    <div class="section"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import { gsap } from 'gsap';

import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
// import GeometryUtils from 'three/examples/jsm/utils/GeometryUtils.js'
import { randomPointsInBufferGeometry } from '../utils/ThreeUtils.js';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

export default {
  name: 'HelloWorld',
  data() {
    return {
      camera: new THREE.PerspectiveCamera(
        45,
        window.innerWidth / window.innerHeight,
        1,
        10000
      ),
      scene: new THREE.Scene(),
      renderer: new THREE.WebGLRenderer(),
      geometry: new THREE.BufferGeometry(),
      color: new THREE.Color(),
      controls: {},
      particleSystem: undefined,
      defaultAnimationSpeed: 1,
      morphAnimationSpeed: 18,
      particleCount: 2000,
      particleSize: 1,
      status: '',
      idx: 0,
    };
  },
  computed: {
    normalSpeed() {
      return this.defaultAnimationSpeed / 100;
    },
    fullSpeed() {
      return this.morphAnimationSpeed / 100;
    },
    animationVars() {
      return {
        speed: this.normalSpeed,
        color: this.color,
        rotation: -45,
      };
    },
    ipfsLink() {
      return window.location.href;
    },
  },
  mounted() {
    // Renderer
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(this.renderer.domElement);

    //Add orbit control
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);

    // Ensure Full Screen on Resize
    window.addEventListener('resize', this.fullScreen, false);

    this.camera.position.y = -45;
    this.camera.position.z = 45;

    // Lighting
    var light = new THREE.AmbientLight(0xffffff, 1);
    this.scene.add(light);

    const colors = [];
    const n = 1000,
      n2 = n / 2; // particles spread in the cube

    for (let i = 0; i < this.particleCount; i++) {
      const x = Math.random() * n - n2;
      const y = Math.random() * n - n2;
      const z = Math.random() * n - n2;

      // colors
      const vx = x / n + 0.5;
      const vy = y / n + 0.5;
      const vz = z / n + 0.5;

      this.color.setRGB(vx, vy, vz);
      colors.push(this.color.r, this.color.g, this.color.b);
    }
    const shpere = new THREE.IcosahedronGeometry(20, 4);
    const spherePoints = this.createPointsArray(
      randomPointsInBufferGeometry(shpere, this.particleCount)
    );

    this.geometry.setAttribute(
      'position',
      new THREE.Float32BufferAttribute(spherePoints, 3)
    );

    this.geometry.setAttribute('color', new THREE.Float32BufferAttribute(colors, 3));

    const material = new THREE.PointsMaterial({
      size: this.particleSize,
      vertexColors: true,
    });
    this.particleSystem = new THREE.Points(this.geometry, material);
    this.scene.add(this.particleSystem);
    this.animate();

    this.onStart();
  },
  methods: {
    fullScreen() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate() {
      if (this.particleSystem) {
        this.particleSystem.rotation.y += this.animationVars.speed;
        this.geometry.verticesNeedUpdate = true;
      }

      this.camera.position.z = this.animationVars.rotation;
      this.camera.position.z = 200;
      this.camera.position.y = this.animationVars.rotation;
      this.camera.lookAt(this.scene.position);

      window.requestAnimationFrame(this.animate);
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
    createPointsArray(points) {
      const array = [];
      for (var p = 0; p < this.particleCount; p++) {
        array.push(points[p]['x'], points[p]['y'], points[p]['z']);
      }
      return array;
    },
    async onStart() {
      // Texts
      const loader = new FontLoader();
      const typeface = 'Mochiy_Pop_P_One_Regular.json';
      const emoji = ['＼`•̀益•́´／', '(@~@)?', '<(`^´)>', '(>x<)', '(♡˙︶˙♡)', '(。_。) '];
      const texts = [];
      this.status = 'loading...';

      loader.load(typeface, (font) => {
        try {
          for (let i = 0; i < 6; i++) {
            texts[i] = {};

            texts[i].geometry = new TextGeometry(emoji[i], {
              font,
              size: window.innerWidth * 0.02,
              height: 4,
              curveSegments: 10,
            });

            texts[i].geometry.center();
            texts[i].points = this.createPointsArray(
              randomPointsInBufferGeometry(texts[i].geometry, this.particleCount)
            );
          }

          // Add the particles to the scene
          gsap.to(this.geometry.attributes.position.array, {
            endArray: new THREE.Float32BufferAttribute(texts[0].points, 3).array,
            duration: 3,
            onUpdate: () => (this.geometry.attributes.position.needsUpdate = true),
          });

          setInterval(() => {
            if (this.idx < 5) {
              this.idx++;
            } else {
              this.idx = 0;
            }

            gsap.to(this.geometry.attributes.position.array, {
              endArray: new THREE.Float32BufferAttribute(texts[this.idx].points, 3).array,
              duration: 3,
              onUpdate: () => (this.geometry.attributes.position.needsUpdate = true),
            });
          }, 7000);

          this.status = 'done';
        } catch (error) {
          console.log(error);
        }
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.button-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  color: white;
  pointer-events: none;
}

.button-container button {
  border: none;
  background: none;
  color: white;
  font-size: 36px;
  font-weight: bold;
  margin: 40px;
  cursor: pointer;
}

.section {
  height: 30%;
  display: flex;
  justify-content: centerß;
  align-items: center;
}

.button-container button:hover {
  color: gray;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

a {
  color: white;
  text-decoration: none;
}
</style>
